import { ComponentProps, ReactElement } from 'react';
import { UsePageFilters } from 'store/pagesFilters/types';
import { CodeNameModel } from 'components/common/types';
import AsyncSelect from 'lib/AsyncSelect';
import { useLoadLookup } from '../useLoadLookup';
import FilterAsyncLookup from '../FilterAsyncLookup';

export interface FilterSalesPersonProps
  extends Omit<ComponentProps<typeof AsyncSelect>, 'loadData' | 'onSelect' | 'selectedValue' | 'name' | 'textKey'> {
  changeFilters: UsePageFilters<SalesPersonFilterModel>['changeFilters'];
  salesPerson?: CodeNameModel;
}

export interface SalesPersonFilterModel {
  salesPerson: CodeNameModel;
}

const FilterSalesPerson = ({ changeFilters, salesPerson }: FilterSalesPersonProps): ReactElement => {
  const { onLoadSalesPerson } = useLoadLookup();

  return (
    <FilterAsyncLookup
      filterKey="salesPerson"
      selectedValue={salesPerson}
      loadData={onLoadSalesPerson}
      changeFilters={changeFilters}
      placeholder="Search sales person"
      dataTestId="salesPerson-filter"
      pendoLabel="Sales person filter"
    />
  );
};

export default FilterSalesPerson;
